import 'react';
import PropTypes from 'prop-types';
import BaseSelect, { components } from 'react-select';
import classNames from 'classnames';
import 'react-icons/fa';
import { jsx, jsxs } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var themes = ['light'
/* , 'dark' */
];
var sizesWithLabel = [{
  label: 'small',
  value: 's'
}, {
  label: 'medium',
  value: 'm'
}, {
  label: 'large',
  value: 'l'
}];
var sizes = sizesWithLabel.map(function (_ref) {
  var value = _ref.value;
  return value;
});

function getPadding(size) {
  switch (size) {
    case 's':
      return 'var(--spacing-01x)';

    case 'm':
      return 'var(--spacing-02x)';

    case 'l':
      return 'var(--spacing-02x)';

    default:
      return 'var(--spacing-02x)';
  }
}

function getControlColor(_ref) {
  var menuIsOpen = _ref.menuIsOpen,
      isDisabled = _ref.isDisabled,
      theme = _ref.theme,
      _ref$hover = _ref.hover,
      hover = _ref$hover === void 0 ? false : _ref$hover;

  if (theme === 'light') {
    if (isDisabled) return 'var(--color-fg-80)';
    if (menuIsOpen) return 'var(--color-fg-80)';
    if (hover) return 'var(--color-fg-80)';
    return 'var(--color-fg-40)';
  }

  return 'var(--color-fg-40)';
}

function getControlBackgroundColor(_ref2) {
  var menuIsOpen = _ref2.menuIsOpen,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      look = _ref2.look,
      _ref2$hover = _ref2.hover,
      hover = _ref2$hover === void 0 ? false : _ref2$hover;

  if (look === 'text' && theme === 'light') {
    if (isDisabled) return 'transparent';
    if (menuIsOpen) return 'var(--color-bg-20)';
    if (hover) return 'var(--color-bg-00)';
    return 'transparent';
  }

  if (look === 'normal' && theme === 'light') {
    if (isDisabled) return 'var(--color-bg-30)';
    if (menuIsOpen) return 'var(--color-bg-20)';
    if (hover) return 'var(--color-bg-10)';
    return 'var(--color-bg-00)';
  }

  return 'transparent';
}

function getControlBorderColor(_ref3) {
  var menuIsOpen = _ref3.menuIsOpen,
      isDisabled = _ref3.isDisabled,
      theme = _ref3.theme,
      _ref3$hover = _ref3.hover,
      hover = _ref3$hover === void 0 ? false : _ref3$hover,
      look = _ref3.look;
  if (look === 'text') return 'transparent';

  if (theme === 'light') {
    if (isDisabled) return 'var(--color-bg-30)';
    if (menuIsOpen) return 'var(--color-info-01)';
    if (hover) return 'var(--color-fg-40)';
    return 'var(--color-fg-40)';
  }

  return 'var(--color-neutral-00)';
}

function getIndicatorColor(_ref4) {
  var menuIsOpen = _ref4.menuIsOpen,
      isDisabled = _ref4.isDisabled,
      theme = _ref4.theme;

  if (theme === 'light') {
    if (isDisabled) return 'var(--color-fg-40)';
    if (menuIsOpen) return 'var(--color-fg-40)';
    return 'var(--color-fg-40)';
  }

  return 'inherit';
}

function getMenuBackgroundColor(_ref5) {
  var theme = _ref5.theme;

  if (theme === 'light') {
    return 'var(--color-bg-00)';
  }

  return 'var(--color-fg-70)';
}

function getMenuBorderColor(_ref6) {
  var theme = _ref6.theme,
      look = _ref6.look;
  if (look === 'text') return 'transparent';

  if (theme === 'light') {
    return 'var(--color-bg-30)';
  }

  return 'var(--color-fg-80)';
}

function getOptionColor(_ref7) {
  var theme = _ref7.theme,
      isDisabled = _ref7.isDisabled,
      _ref7$hover = _ref7.hover,
      hover = _ref7$hover === void 0 ? false : _ref7$hover;

  if (theme === 'light') {
    if (isDisabled) return 'var(--color-fg-30)';
    if (hover) return 'var(--color-fg-80)';
    return 'var(--color-fg-80)';
  }

  return 'var(--color-bg-20)';
}

function getOptionBackgroundColor(_ref8) {
  var theme = _ref8.theme,
      isDisabled = _ref8.isDisabled,
      _ref8$hover = _ref8.hover,
      hover = _ref8$hover === void 0 ? false : _ref8$hover;

  if (theme === 'light') {
    if (isDisabled) return 'var(--color-bg-20)';
    if (hover) return 'var(--color-bg-10)';
    return 'transparent';
  }

  return 'transparent';
}

function getStyles(_ref9) {
  var size = _ref9.size,
      theme = _ref9.theme,
      look = _ref9.look;
  return {
    clearIndicator: function clearIndicator(provided, state) {
      var _state$selectProps = state.selectProps,
          menuIsOpen = _state$selectProps.menuIsOpen,
          isDisabled = _state$selectProps.isDisabled;
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        color: getIndicatorColor({
          menuIsOpen: menuIsOpen,
          isDisabled: isDisabled,
          theme: theme,
          hover: false
        }),
        transform: menuIsOpen ? 'rotate(180deg)' : undefined,
        margin: '0',
        padding: '0',
        '&:hover': {
          color: getIndicatorColor({
            menuIsOpen: menuIsOpen,
            isDisabled: isDisabled,
            theme: theme,
            hover: true
          })
        }
      });
    },
    container: function container(provided) {
      return _objectSpread2({}, provided);
    },
    control: function control(provided, state) {
      var menuIsOpen = state.menuIsOpen,
          isDisabled = state.isDisabled;
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        minHeight: 0,
        boxShadow: undefined,
        backgroundColor: getControlBackgroundColor({
          menuIsOpen: menuIsOpen,
          isDisabled: isDisabled,
          theme: theme,
          look: look
        }),
        borderColor: getControlBorderColor({
          menuIsOpen: menuIsOpen,
          isDisabled: isDisabled,
          theme: theme,
          look: look
        }),
        color: getControlColor({
          menuIsOpen: menuIsOpen,
          isDisabled: isDisabled,
          theme: theme
        }),
        fontWeight: 'var(--font-weight-semi-bold)',
        padding: getPadding(size),
        opacity: isDisabled ? 'var(--opacity-04)' : 'var(--opacity-10)',
        transition: undefined,
        transitionProperty: 'color, background-color, border-color',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease',
        '&:hover': {
          color: getControlColor({
            menuIsOpen: menuIsOpen,
            isDisabled: isDisabled,
            theme: theme,
            hover: true
          }),
          borderColor: getControlBorderColor({
            menuIsOpen: menuIsOpen,
            isDisabled: isDisabled,
            theme: theme,
            hover: true,
            look: look
          }),
          backgroundColor: getControlBackgroundColor({
            menuIsOpen: menuIsOpen,
            isDisabled: isDisabled,
            theme: theme,
            hover: true
          }),
          boxShadow: 'var(--shadow-03)'
        }
      });
    },
    dropdownIndicator: function dropdownIndicator(provided, state) {
      var _state$selectProps2 = state.selectProps,
          menuIsOpen = _state$selectProps2.menuIsOpen,
          isDisabled = _state$selectProps2.isDisabled;
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        color: getIndicatorColor({
          menuIsOpen: menuIsOpen,
          isDisabled: isDisabled,
          theme: theme,
          hover: false
        }),
        transform: menuIsOpen ? 'rotate(180deg)' : undefined,
        margin: '0',
        padding: '0',
        '&:hover': {
          color: getIndicatorColor({
            menuIsOpen: menuIsOpen,
            isDisabled: isDisabled,
            theme: theme,
            hover: true
          })
        }
      });
    },
    group: function group(provided) {
      return _objectSpread2({}, provided);
    },
    groupHeading: function groupHeading(provided) {
      return _objectSpread2({}, provided);
    },
    indicatorsContainer: function indicatorsContainer(provided) {
      return _objectSpread2({}, provided);
    },
    indicatorSeparator: function indicatorSeparator(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        backgroundColor: 'transparent'
      });
    },
    input: function input(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        margin: '0',
        padding: '0'
      });
    },
    loadingIndicator: function loadingIndicator(provided) {
      return _objectSpread2({}, provided);
    },
    loadingMessage: function loadingMessage(provided) {
      return _objectSpread2({}, provided);
    },
    menu: function menu(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        backgroundColor: getMenuBackgroundColor({
          theme: theme
        }),
        borderColor: getMenuBorderColor({
          theme: theme
        }),
        padding: 'var(--spacing-01x)'
      });
    },
    menuList: function menuList(provided) {
      return _objectSpread2({}, provided);
    },
    menuPortal: function menuPortal(provided) {
      return _objectSpread2({}, provided);
    },
    multiValue: function multiValue(provided) {
      return _objectSpread2({}, provided);
    },
    multiValueLabel: function multiValueLabel(provided) {
      return _objectSpread2({}, provided);
    },
    multiValueRemove: function multiValueRemove(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        backgroundColor: 'transparent',
        color: 'var(--color-fg-95)',
        borderRadius: '50%',
        borderWidth: '--border-w-02',
        borderStyle: 'solid',
        borderColor: 'var(--color-fg-95)',
        width: 'var(--size-04)',
        height: 'var(--size-04)',
        padding: '0',
        fontWeight: 'var(--font-weight-semi-bold)',
        alignSelf: 'center',
        textJustify: 'center',
        marginLeft: 'var(--spacing-01x)',
        transitionProperty: 'color, background-color, border-color',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease',
        '&:hover': {
          backgroundColor: 'transparent',
          color: 'var(--color-danger-01)',
          borderColor: 'var(--color-danger-01)'
        }
      });
    },
    noOptionsMessage: function noOptionsMessage(provided) {
      return _objectSpread2({}, provided);
    },
    option: function option(provided, state) {
      var isDisabled = state.isDisabled;
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        color: getOptionColor({
          theme: theme,
          isDisabled: isDisabled
        }),
        borderRadius: 'var(--border-r-xs)',
        backgroundColor: getOptionBackgroundColor({
          theme: theme,
          isDisabled: isDisabled
        }),
        '&:hover': {
          backgroundColor: getOptionBackgroundColor({
            theme: theme,
            isDisabled: isDisabled,
            hover: true
          }),
          color: getOptionColor({
            theme: theme,
            isDisabled: isDisabled,
            hover: true
          })
        }
      });
    },
    placeholder: function placeholder(provided, state) {
      var isDisabled = state.isDisabled;
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        margin: '0',
        padding: '0',
        color: getControlColor({
          theme: theme,
          hover: false,
          isDisabled: isDisabled
        })
      });
    },
    singleValue: function singleValue(provided, state) {
      var isDisabled = state.isDisabled,
          menuIsOpen = state.menuIsOpen;
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        color: getControlColor({
          menuIsOpen: menuIsOpen,
          isDisabled: isDisabled,
          hover: false
        }),
        fontWeight: 'var(--font-weight-semi-bold)'
      });
    },
    valueContainer: function valueContainer(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        margin: '0',
        padding: '0'
      });
    }
  };
}

var _excluded = ["children"],
    _excluded2 = ["options", "value", "isMulti", "className", "size", "theme", "disabled", "look", "icon"];
var prefix = 'forno-dropdown';
/**
 * Renders a `<Dropdown/>` component
 * @param {Object} props
 * @param {arrayOf(Object)} [props.options=[]] - Options
 * @param {string, number, [string], [number]} [props.value=] - Selected value
 * @param {boolean} [props.isMulti=false] - Multiselect
 * @param {string} [props.className=] - Custom class name
 * @param {string} [props.size=medium] - [small, medium, large]
 * @param {string} [props.theme=light] - [light, dark]
 * @param {boolean} [props.disabled=false] - Disabled
 * @param {string} [props.placeholder=] - Placeholder
 * @param {string} [props.look=normal] - [normal, text]
 * @param {func} [props.icon=Icon] - Icon
  
 }} [props.icon]
 */

function Control(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var icon = props.selectProps.icon;
  return /*#__PURE__*/jsxs(components.Control, _objectSpread2(_objectSpread2({}, props), {}, {
    children: [icon ? /*#__PURE__*/jsx("div", {
      className: "".concat(prefix, "-icon-container"),
      children: icon
    }) : null, children]
  }));
}

function Select(_ref2) {
  var options = _ref2.options;
      _ref2.value;
      var isMulti = _ref2.isMulti,
      className = _ref2.className,
      size = _ref2.size,
      theme = _ref2.theme,
      disabled = _ref2.disabled,
      look = _ref2.look,
      Icon = _ref2.icon,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var typography = "font-block-".concat(size, "-sb");
  var customClassName = classNames(prefix, className, typography);
  return /*#__PURE__*/jsx(BaseSelect, _objectSpread2({
    className: customClassName,
    classNamePrefix: prefix,
    isOptionDisabled: function isOptionDisabled(option) {
      return option.disabled;
    },
    isMulti: isMulti,
    isDisabled: disabled,
    options: options,
    styles: getStyles({
      size: size,
      theme: theme,
      look: look
    }),
    look: look,
    icon: Icon ? /*#__PURE__*/jsx(Icon, {}) : null,
    components: {
      Control: Control
    }
  }, rest));
}

Control.propTypes = {
  icon: PropTypes.func,
  children: PropTypes.node,
  selectProps: PropTypes.shape({
    icon: PropTypes.node
  })
};
Control.defaultProps = {
  icon: null,
  children: null,
  selectProps: {}
};
Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  isMulti: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.number)]),
  className: PropTypes.string,
  size: PropTypes.oneOf(sizes),
  theme: PropTypes.oneOf(themes),
  disabled: PropTypes.bool,
  look: PropTypes.oneOf(['text', 'normal']),
  icon: PropTypes.func
};
Select.defaultProps = {
  options: [],
  className: null,
  isMulti: false,
  value: null,
  size: 'm',
  theme: 'light',
  disabled: false,
  look: 'normal',
  icon: null
};

export { Select as default, prefix };
